import { render } from "./brandlist.vue?vue&type=template&id=a4787b0e"
import script from "./brandlist.vue?vue&type=script&lang=js"
export * from "./brandlist.vue?vue&type=script&lang=js"

import "./brandlist.vue?vue&type=style&index=0&id=a4787b0e&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__